import { Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { RoutePaths } from '@shared/utils';
import { NonAuthFormLayout } from '@widgets';
import { Login, PasswordRecovery, Register } from '@pages';

export const Public = () => {
  const { t } = useTranslation(['register', 'remember']);

  return (
    <Routes>
      <Route path={RoutePaths.register.path} element={<NonAuthFormLayout component={Register} header={t('title', { ns: 'register' })} />} />
      <Route path={RoutePaths.remember.path} element={<NonAuthFormLayout component={PasswordRecovery} header={t('title', { ns: 'remember' })} />} />
      <Route path={RoutePaths.login.path} element={<NonAuthFormLayout component={Login} />} />
      <Route path='*' element={<NonAuthFormLayout component={Login} />} />
    </Routes>
  );
};
